// nuolino-admin/src/lib/http-errors.ts
// Hierarquia de erros HTTP. AuthProvider consome `UnauthorizedError` para deslogar.

export class HttpError extends Error {
  readonly status: number;
  readonly body: unknown;
  constructor(message: string, status: number, body: unknown) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
    this.body = body;
  }
}

export class ApiError extends HttpError {
  constructor(message: string, status: number, body: unknown) {
    super(message, status, body);
    this.name = 'ApiError';
  }
}

export class UnauthorizedError extends HttpError {
  constructor(message = 'Unauthorized', body: unknown = null) {
    super(message, 401, body);
    this.name = 'UnauthorizedError';
  }
}

export class NetworkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NetworkError';
  }
}

export class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }
}
